module.exports = "<button class=\"wg-icon\" md-button mdTooltip=\"{{ 'DELETE' | tooltip }} \"   color='primary'  (click)=\"deletePlaylist($event)\">\n    <i class=\"material-icons icon trashcan\"></i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/delete-playlist/delete-playlist.component.html
// module id = ./src/app/shared/delete-playlist/delete-playlist.component.html
// module chunks = main